import { render, staticRenderFns } from "./PasswordForgotScreen.vue?vue&type=template&id=7f0473b7&scoped=true&lang=pug"
import script from "./PasswordForgotScreen.vue?vue&type=script&lang=ts"
export * from "./PasswordForgotScreen.vue?vue&type=script&lang=ts"
import style0 from "./PasswordForgotScreen.vue?vue&type=style&index=0&id=7f0473b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0473b7",
  null
  
)

export default component.exports